import { css, cx } from '@linaria/core';
import { IconCheck, IconLines } from 'components/Icons';
import { Popover, PopoverAction, usePopoverState } from 'components/Popover';
import { baseTheme } from 'styles/utils';
export enum SortType {
  AtoZ = 'A to Z',
  LAST_UPDATED = 'Last Updated',
}
export const sortQueryParam: Record<string, string> = {
  [SortType.AtoZ]: 'sort_by_name=true&sort_ascending=true',
  [SortType.LAST_UPDATED]: 'sort_by_modified_at=true'
};
type SortListPopoverProps = {
  sortType: string;
  onSortChange: React.Dispatch<React.SetStateAction<string>>;
};
export const SortListPopover: React.FC<SortListPopoverProps> = ({
  sortType,
  onSortChange
}) => {
  const popover = usePopoverState({
    placement: 'bottom-end'
  });
  return <>
      <PopoverAction popover={popover} data-testid="app-sort-popover-action" data-collapsed="false" className={SortListPopoverStyles.sortButtonContainer}>
        <button type="button" data-testid="sort-action-container">
          <IconLines size={16} />
        </button>
      </PopoverAction>
      <Popover className={SortListPopoverStyles.sortPopoverAction} data-testid="app-sort-popover" tabIndex={0} aria-label="app-sort-popover" popover={popover}>
        {Object.keys(sortQueryParam).map((key: string) => <button key={key} data-testid="popover-sort-btn" type="button" className={cx(sortType === key && 'selected')} onClick={() => {
        onSortChange(key);
      }}>
            <p data-testid={`sort-label-${key}`}>{key}</p>
            {sortType === key && <IconCheck data-testid="icon-check" size={20} color={baseTheme.light.colors.primary600} />}
          </button>)}
      </Popover>
    </>;
};
const SortListPopoverStyles = {
  sortButtonContainer: "omponents__SidebarV2__SortPopover_tsx-sortButtonContainer-s1lxcylp",
  sortPopoverAction: "omponents__SidebarV2__SortPopover_tsx-sortPopoverAction-s1pelsz2"
};

require("./SortPopover.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./SortPopover.tsx");